/*
 * Recharge for everyone: every selling plan a page sends to the cart is swapped from the Appstle plan to its
 * Recharge twin (same product), and the $29 Guide that only Appstle makes free is swapped for the $0 Guide.
 * On for every visitor since 2026-10-13 (it used to be a ?recharge=1 test mode). Do not delete after launch:
 * the Replo pages still carry Appstle plan ids, and Replo code reads window.SPRKL_RECHARGE_TEST for the $0 Guide.
 * It reaches:
 *   - config left by Replo head code (SPRKL_DIRECT_CHECKOUT_OFFER, *_SELLING_PLAN_ID, FREE_VARIANT_ID, data-selling-plan-id)
 *   - fetch / XHR to /cart/add, /cart/update, /cart/change and the Storefront API (cartCreate)
 *   - <input name="…selling_plan"> on submitted forms and …selling_plan=… links
 * Every swap is logged to the console as [recharge-test].
 * Map generated 2026-10-07 from the Appstle -> Recharge plan table; checked against the live plans 2026-10-13.
 */
(function () {
  "use strict";
  window.SPRKL_RECHARGE_TEST = true;

  // "variantId:appstlePlanId" -> Recharge plan id. Exact per product.
  var BY_VARIANT = {
    "52751014297929:692013269321": "692501119305",
    "53438908563785:690709594441": "692501479753",
    "53438908563785:692013269321": "692501479753",
    "53438908563785:692149485897": "692501446985",
    "53438908563785:692171112777": "692501774665",
    "53438908563785:692234584393": "692501414217",
    "53438908563785:692259258697": "692501741897",
    "53438908563785:692294091081": "692501414217",
    "53438908563785:692315291977": "692501381449",
    "53924418289993:691683033417": "692501905737",
    "53924418289993:692013302089": "692501905737",
    "53924418289993:692234781001": "692501348681",
    "53924418289993:692294123849": "692501348681",
    "54400348881225:692259324233": "692501315913",
    "54565277827401:692304347465": "692501283145",
    "54565277827401:692304380233": "692501807433",
    "54565277827401:692304413001": "692501840201",
    "54585335513417:692311163209": "692501250377",
    "54585335513417:692311195977": "692501872969",
    "54585335513417:692311228745": "692501217609",
    "54609086218569:692315324745": "692501938505",
    "54611255624009:692315390281": "692501971273",
    "54673376117065:692324401481": "692501512521",
    "54739666403657:692336558409": "692501578057",
    "54739666403657:692381647177": "692501545289",
    "54772744683849:692336525641": "692501676361",
    "54772744683849:692381188425": "692501610825",
    "54772744683849:692407894345": "692501709129",
    "54772744683849:692407927113": "692501643593",
    "54818296889673:692349469001": "692501086537",
    "54825486221641:692350026057": "692502004041",
    "54845927850313:692360806729": "692502036809",
    "54845927850313:692365525321": "692502069577",
    "55003073282377:692013269321": "692495352137",
    "55003074036041:692013269321": "692501184841",
    "55003074363721:692013269321": "692501152073"
  };
  // Appstle plan id -> Recharge plan id, for plans that live on one product only.
  // (692013269321 is shared by five products, so it is only swapped through BY_VARIANT.)
  var BY_PLAN = {
    "690709594441": "692501479753",
    "691683033417": "692501905737",
    "692013302089": "692501905737",
    "692149485897": "692501446985",
    "692171112777": "692501774665",
    "692234584393": "692501414217",
    "692234781001": "692501348681",
    "692259258697": "692501741897",
    "692259324233": "692501315913",
    "692294091081": "692501414217",
    "692294123849": "692501348681",
    "692304347465": "692501283145",
    "692304380233": "692501807433",
    "692304413001": "692501840201",
    "692311163209": "692501250377",
    "692311195977": "692501872969",
    "692311228745": "692501217609",
    "692315291977": "692501381449",
    "692315324745": "692501938505",
    "692315390281": "692501971273",
    "692324401481": "692501512521",
    "692336525641": "692501676361",
    "692336558409": "692501578057",
    "692349469001": "692501086537",
    "692350026057": "692502004041",
    "692360806729": "692502036809",
    "692365525321": "692502069577",
    "692381188425": "692501610825",
    "692381647177": "692501545289",
    "692407894345": "692501709129",
    "692407927113": "692501643593"
  };
  // Gift variants Appstle makes free -> a variant that is $0 on its own.
  var GIFTS = { "53446434652489": "54833068540233" };

  function log(what, from, to) {
    try { console.info("[recharge-test]", what, from, "->", to); } catch (e) {}
  }
  function num(x) {
    var m = String(x == null ? "" : x).match(/(\d{6,})$/);
    return m ? m[1] : "";
  }
  function plan(variant, p) {
    p = num(p);
    if (!p) return null;
    return BY_VARIANT[num(variant) + ":" + p] || BY_PLAN[p] || null;
  }
  // Keep the shape the caller used: number, numeric string or gid.
  function same(orig, id) {
    if (typeof orig === "number") return Number(id);
    var s = String(orig);
    return s.indexOf("gid://") === 0 ? s.replace(/\d+$/, id) : id;
  }

  var VARIANT_KEYS = ["id", "variant_id", "variantId", "merchandiseId"];
  var PLAN_KEYS = ["selling_plan", "sellingPlanId", "selling_plan_id"];

  function fixLine(o, adding) {
    var vk = null;
    for (var i = 0; i < VARIANT_KEYS.length; i++) if (o[VARIANT_KEYS[i]] != null) { vk = VARIANT_KEYS[i]; break; }
    var variant = vk ? o[vk] : "";
    PLAN_KEYS.forEach(function (k) {
      if (o[k] == null) return;
      var to = plan(variant, o[k]);
      if (to) { log("plan", o[k], to); o[k] = same(o[k], to); }
    });
    if (adding && vk && GIFTS[num(variant)]) {
      log("gift", variant, GIFTS[num(variant)]);
      o[vk] = same(variant, GIFTS[num(variant)]);
    }
  }
  function walk(x, adding) {
    if (Array.isArray(x)) x.forEach(function (y) { walk(y, adding); });
    else if (x && typeof x === "object") {
      fixLine(x, adding);
      Object.keys(x).forEach(function (k) { walk(x[k], adding); });
    }
  }
  // URLSearchParams / FormData: "id" + "selling_plan", or "items[0][id]" + "items[0][selling_plan]".
  function fixParams(p, adding) {
    var keys = [];
    p.forEach(function (v, k) { if (keys.indexOf(k) < 0) keys.push(k); });
    keys.forEach(function (k) {
      var m = k.match(/^(.*)selling_plan(\]?)$/);
      if (!m) return;
      var to = plan(p.get(m[1] + "id" + m[2]), p.get(k));
      if (to) { log("plan", p.get(k), to); p.set(k, to); }
    });
    if (adding) keys.forEach(function (k) {
      if (!/(^|\[)id\]?$/.test(k)) return;
      var g = GIFTS[num(p.get(k))];
      if (g) { log("gift", p.get(k), g); p.set(k, g); }
    });
    return p;
  }

  var CART = /\/cart\/(add|update|change)|\/api\/[^/]+\/graphql/;
  function isAdd(url) {
    return /\/cart\/add|\/api\/[^/]+\/graphql/.test(url);
  }
  function fixBody(body, url) {
    var adding = isAdd(url);
    if (typeof body === "string") {
      try {
        var j = JSON.parse(body);
        walk(j, adding);
        return JSON.stringify(j);
      } catch (e) {
        var before = new URLSearchParams(body).toString();
        var after = fixParams(new URLSearchParams(body), adding).toString();
        return after === before ? body : after;
      }
    }
    if (body instanceof URLSearchParams || (typeof FormData !== "undefined" && body instanceof FormData)) {
      return fixParams(body, adding);
    }
    return body;
  }
  function fixUrl(url) {
    if (String(url).indexOf("selling_plan") < 0) return url;
    try {
      var u = new URL(url, location.href);
      fixParams(u.searchParams, /\/cart\/add/.test(u.pathname));
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        if (typeof input === "string") input = fixUrl(input);
        if (CART.test(url) && init && init.body != null) {
          init = Object.assign({}, init, { body: fixBody(init.body, url) });
        }
      } catch (e) {}
      return origFetch.call(this, input, init);
    };
  }
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__sprklUrl = String(url);
    var args = Array.prototype.slice.call(arguments);
    args[1] = fixUrl(String(url));
    return xhrOpen.apply(this, args);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (body != null && CART.test(this.__sprklUrl || "")) body = fixBody(body, this.__sprklUrl);
    } catch (e) {}
    return xhrSend.call(this, body);
  };

  // Native form posts and plain links.
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f || !f.querySelectorAll) return;
    var idInput = f.querySelector("[name='id']");
    f.querySelectorAll("[name$='selling_plan']").forEach(function (input) {
      if (input.type === "radio" && !input.checked) return;
      var to = plan(idInput && idInput.value, input.value);
      if (to) { log("plan", input.value, to); input.value = to; }
    });
  }, true);
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest && e.target.closest("a[href*='selling_plan']");
    if (a) a.href = fixUrl(a.href);
  }, true);

  // Config the Replo head code leaves on window (read at click time).
  function fixGlobals() {
    var w = window;
    var cfg = w.SPRKL_DIRECT_CHECKOUT_OFFER;
    if (cfg && cfg.buttons) {
      Object.keys(cfg.buttons).forEach(function (k) {
        var b = cfg.buttons[k];
        var to = b && plan(b.variantId, b.sellingPlanId);
        if (to) { log(k, b.sellingPlanId, to); b.sellingPlanId = Number(to); }
      });
    }
    [
      ["MONTHLY_SELLING_PLAN_ID", w.LIQUID_COLLAGEN_VARIANT_ID || w.PDRN_SERUM_VARIANT_ID],
      ["BUNDLE_DOUBLE_SELLING_PLAN_ID", w.BUNDLE_DOUBLE_VARIANT_ID],
      ["BUNDLE_2PACK_SELLING_PLAN_ID", w.BUNDLE_2PACK_VARIANT_ID],
      ["SPRING_VOLUME_SELLING_PLAN_DEFAULT", ""],
    ].forEach(function (pair) {
      var to = plan(pair[1], w[pair[0]]);
      if (to) { log(pair[0], w[pair[0]], to); w[pair[0]] = Number(to); }
    });
    ["FREE_VARIANT_ID", "BUNDLE_DOUBLE_FREE_VARIANT_ID"].forEach(function (k) {
      var g = GIFTS[num(w[k])];
      if (g) { log(k, w[k], g); w[k] = Number(g); }
    });
    document.querySelectorAll("[data-selling-plan-id]").forEach(function (el) {
      var to = plan(el.getAttribute("data-variant-id"), el.getAttribute("data-selling-plan-id"));
      if (to) el.setAttribute("data-selling-plan-id", to);
    });
  }
  fixGlobals();
  document.addEventListener("DOMContentLoaded", fixGlobals);
  window.addEventListener("load", fixGlobals);
})();
